import React from 'react'
import Badge from '../../../../components/Badge'
import { isStatusChipLegendActive } from './accountStatusUtils'

export interface StatusChipTooltipContentProps {
  label: string
  values?: string[]
  currentStatus?: string | null
  description?: string
}

/** Soft Badge legend for status-chip tooltips; inactive values render grey. */
export const StatusChipTooltipContent: React.FC<StatusChipTooltipContentProps> = ({
  label,
  values = [],
  currentStatus,
  description,
}) => (
  <div className="space-y-2 text-left">
    <div className="text-xs font-medium text-white">{label}</div>
    {description != null && description !== '' ? (
      <p className="mb-0 max-w-xs text-xs font-normal leading-snug text-slate-200">{description}</p>
    ) : null}
    {values.length > 0 ? (
      <div className="flex max-w-sm flex-wrap gap-1.5">
        {values.map((value) => {
          const active = isStatusChipLegendActive(value, currentStatus)
          return (
            <span
              key={value}
              data-testid={`status-chip-legend-${value}`}
              data-active={active ? 'true' : 'false'}
              className="inline-flex"
            >
              <Badge status={value} variant="soft" muted={!active} />
            </span>
          )
        })}
      </div>
    ) : null}
  </div>
)

export default StatusChipTooltipContent
